import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=26339896"
import script from "./ClientList.vue?vue&type=script&lang=ts"
export * from "./ClientList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports